import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from '../base/model';
import { format, getConnectorV2Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { SalesforceV2LinkedService } from '../linkedservice/salesforce-v2.linkedservice';
import { SalesforceSourceOptionEnum } from '../../constants/dataset-constants';
import { TabularTypeDataset } from './tabular-type.dataset';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

@Metamodel.model({
    name: ModelConstants.salesforceV2Dataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, getConnectorV2Name(shellStringResources.Salesforce_DisplayText, isTridentInIframe())),
        format(shellStringResources.ModelName_DatasetsTemplate, getConnectorV2Name(shellStringResources.Salesforce_DisplayText, isTridentInIframe()))
    ],
    constraints: {
        linkedService: {
            model: SalesforceV2LinkedService.MODEL // Linked service redefined
        }
    }
})
export class SalesforceV2Dataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly SOURCE_OPTION: IAttribute;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }

    @Metamodel.attribute({
        association: 'SOURCE_OPTION',
    })
    public sourceOption: SalesforceSourceOptionEnum = 'objectApiName';
}
